export const colorShade = (color, amount) => {
    color = color.replace(/^#/, "");
    if (color.length === 3)
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
    let [r, g, b] = color.match(/.{2}/g);
    [r, g, b] = [
        parseInt(r, 16) + amount,
        parseInt(g, 16) + amount,
        parseInt(b, 16) + amount,
    ];
    r = Math.max(Math.min(255, r), 0).toString(16);
    g = Math.max(Math.min(255, g), 0).toString(16);
    b = Math.max(Math.min(255, b), 0).toString(16);
    const rr = (r.length < 2 ? "0" : "") + r;
    const gg = (g.length < 2 ? "0" : "") + g;
    const bb = (b.length < 2 ? "0" : "") + b;
    return `#${rr}${gg}${bb}`;
};
export const hexToRGB = (color) => [1, 3, 5].map((i) => parseInt(color.substring(i, i + 2), 16));
export const tone = (color, amount) => "#".concat(hexToRGB(color)
    .map((c) => clamp(c + amount, 0, 255)
    .toString(16)
    .padStart(2, "0"))
    .join(""));
const clamp = (number, lower, upper) => {
    if (number < lower) {
        return lower;
    }
    if (number > upper) {
        return upper;
    }
    return number;
};
